/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Header Down Sort Icon component.
 */
export const HeaderSortDownIcon = ({
  size = IconSize.largeMedium,
  color = dlsColor('darkTeal')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_21088_95419)'>
        <rect x='2' y='1' width={iconSize} height={iconSize} rx='8' fill={dlsColor('paleBlue')} shapeRendering='crispEdges' />
        <path d='M14 19.6176L17.6715 22.9999L21.1912 19.6176' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M17.5919 12V21.8581' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <filter id='filter0_d_21088_95419' x='0' y='0' width='36' height='36' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='1' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_21088_95419' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_21088_95419' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

export default HeaderSortDownIcon;
